import React, { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { Scrollama, Step } from 'react-scrollama';

// function toggleMute(target) {
//   var video = target;

//   video.muted = !video.muted;
// }

export const SlideshowComponent = (
  images,
  contents,
  slideshowType,
  uuid,
  isFeatured
) => {
  // console.log(images);
  useEffect(() => {
    // in mobile slideshow, setting loading prefs
    if (slideshowType === 'mobile') {
      var allVideos = document
        .getElementById(uuid)
        .getElementsByTagName('video');
      console.log(allVideos);

      for (let source = 0; source < 2; source++) {
        let singleVideo = Object.values(allVideos)[source].children[0];
        console.log(singleVideo);
        !singleVideo.src && (singleVideo.src = singleVideo.dataset.src);
      }
    }
  });

  const [offset, setOffset] = useState(0);

  useEffect(() => {
    setOffset(
      document
        .getElementsByClassName('slideshow-container-full')[0]
        .getBoundingClientRect().x
    );
  });

  useEffect(() => {
    function handleResize() {
      setOffset(
        document
          .getElementsByClassName('slideshow-container-full')[0]
          .getBoundingClientRect().x
      );
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Mobile slideshow config options
  // const singleImageClass = twMerge(
  //   slideshowType === 'mobile'
  //     ? 'my-auto mx-auto h-screen w-[280px] h-[90lvh] object-cover rounded-full'
  //     : 'h-screen w-screen object-cover md:object-center'
  // );

  // useEffect(() => {
  //   const allVideos = document.getElementsByTagName('video');
  //   console.log(allVideos);
  // }, []);

  // twMerge classes
  const slideshowOffset = `-left-[${Math.trunc(offset)}px]`;
  const opacityFull = 'opacity-100';
  const opacityNone = 'opacity-0';
  const queryId = 'image-slide';

  const onStepEnter = ({ data, direction }) => {
    // setCurrentStepIndex(data.stepIndex);
    // console.log(`Entered ${data.stepIndex}, ${direction}`);
    // console.log(`this is my data: ${data.uuid}`);

    const activeImage = document.querySelector(`.active.${data.uuid}.${uuid}`);
    const currentVisible = document.querySelector(
      `.${queryId}.${data.content.slide}`
    );

    if (activeImage !== currentVisible) {
      currentVisible.classList.replace(opacityNone, opacityFull);
      currentVisible.classList.add('active');
      let currentVisibleVideo = currentVisible.querySelector(':scope>video');
      // currentVisibleVideo.volume = 1;
      // console.log(`curent video is ${currentVisibleVideo.outerHTML}`);

      // progressive loading of many videos, useful for mobile "tiktok" slideshow
      if (slideshowType === 'mobile') {
        if (data.stepIndex !== contents.length - 1) {
          let nextVideo =
            currentVisible.nextSibling.querySelector(':scope>video');
          let nextVideoSource = currentVisible.nextSibling.querySelector(
            ':scope>video>source'
          );
          console.log(`next video source:`);
          console.log(nextVideo);
          if (!nextVideoSource.src) {
            nextVideoSource.src = nextVideoSource.dataset.src;
            nextVideo.load();
          }
        }
      }

      activeImage.classList.replace(opacityFull, opacityNone);
      activeImage.classList.remove('active');
      // let activeVideo = activeImage.querySelector(':scope>video');
      // activeVideo.volume = 0;
    }
  };

  const onStepExit = ({ data, direction }) => {
    // if (contents.length - 1 === data.stepIndex) {
    //   console.log('last step exit');
    //   document.querySelector(`.active.${data.uuid}.${uuid}>video`).volume = 0;
    // }
  };

  // const opacity = (currentStepIndex, stepIndex) =>
  //   currentStepIndex === stepIndex ? 'opacity-full' : 'opacity-10';

  if (slideshowType === 'mobile') {
    return mobileSlideshow(images, contents);
  } else {
    if (isFeatured) {
      return (
        <div id={uuid} className="slideshow-container-full h-full">
          <div className="not-prose relative right-0 left-0 z-50 w-screen transform-none">
            {slideShow(images, contents)}
          </div>
        </div>
      );
    } else {
      return (
        <div id={uuid} className="slideshow-container-full h-full">
          {/* <div className="no-prose fixed top-5 left-4 z-50 bg-red-950 p-4 font-sans text-xl text-white uppercase">
            <p className="m-0 p-0">{Math.trunc(offset)}</p>
          </div> */}
          <div
            className="slideshow-offset not-prose relative z-50 w-screen"
            style={{ left: `-${Math.trunc(offset)}px` }}
          >
            {/* <div className="not-prose relative right-[50%] left-[50%] z-50 -mx-[50vw] w-screen transform-none md:right-0 md:left-0 md:mx-0 md:-translate-x-[20.27%] xl:-translate-x-[23.2%]"> */}
            {slideShow(images, contents)}
          </div>
        </div>
      );
    }
  }

  function slideShow(images, contents) {
    return (
      <>
        <div className="slideshow-container sticky top-0 z-10 h-[100lvh] w-screen overflow-x-hidden bg-slate-600">
          {images.map((image, index) => (
            <div
              id={`image-${image.slide}`}
              className={twMerge(
                uuid,
                image.slide,
                index === 0 ? 'active opacity-100' : 'opacity-0',
                'image-slide absolute flex h-full justify-center align-middle transition-opacity duration-300'
              )}
            >
              {image.url.substring(image.url.length - 3) === 'mp4' && (
                <>
                  <video
                    autoplay="true"
                    muted
                    loop
                    playsInline
                    className={twMerge(
                      uuid,
                      'video h-screen w-screen object-cover object-center'
                    )}
                  >
                    <source src={image.url} type="video/mp4" />
                  </video>
                </>
              )}
              {image.url.substring(image.url.length - 3) !== 'mp4' && (
                <img
                  src={image.url}
                  alt={image.alt}
                  className={twMerge(
                    image.position,
                    `h-screen w-screen object-cover md:object-center`
                  )}
                />
              )}
            </div>
          ))}
        </div>
        <div className="content-container relative -top-[100lvh]">
          <Scrollama
            offset={0.5}
            onStepEnter={onStepEnter}
            onStepExit={onStepExit}
            // debug
          >
            {contents.map((content, stepIndex) => (
              <Step data={{ content, uuid, stepIndex }} key={stepIndex}>
                <div
                  id={content.slide}
                  className="not-prose relative z-20 w-full place-items-end text-white *:pl-2 *:text-white"
                >
                  <div className="spacer h-[50lvh]"></div>
                  <div className="innerContent mx-auto w-11/12 md:w-8/12">
                    <h2 className="relative font-sans text-2xl leading-snug text-white drop-shadow-[0_3px_1px_rgba(0,0,0,1)] md:text-4xl xl:text-4xl">
                      {content.content}
                    </h2>
                  </div>
                  <div
                    className={
                      stepIndex === contents.length - 1 ? 'h-0' : 'h-[50lvh]'
                    }
                  ></div>
                </div>
              </Step>
            ))}
          </Scrollama>
        </div>
      </>
    );
  }

  function mobileSlideshow(images, contents) {
    // const iphoneSize = `h-[85lvh] w-[calc(85lvh*0.45)]`;

    return (
      <div id={uuid} className="slideshow-container-full h-full">
        <div className="prose mx-auto pb-16">
          <div className="not-prose animate-fade-from-black slideshow-container sticky top-20 z-10 flex h-[85lvh] place-content-center bg-transparent">
            <div className="absolute top-0 z-50 flex h-[85lvh] w-full justify-center">
              <img
                src="/assets/iphone-14-midnight.png"
                alt="iphone bg"
                className={twMerge(`h-[85lvh] object-cover`)}
              />
            </div>
            {images.map((image, index) => (
              <div
                id={`image-${image.slide}`}
                className={twMerge(
                  uuid,
                  image.slide,
                  index === 0 ? 'active opacity-100' : 'opacity-0',
                  'image-slide absolute flex h-[85lvh] justify-center overflow-hidden py-4 align-middle transition-opacity duration-300'
                )}
              >
                {/* <div className="absolute bottom-0 z-50 h-[90lvh] w-screen bg-mobile bg-contain bg-center bg-no-repeat"></div> */}
                {image.url.substring(image.url.length - 3) === 'mp4' && (
                  <>
                    <video
                      autoplay="true"
                      muted
                      loop
                      playsInline
                      className="h-full rounded-4xl object-cover object-center"
                    >
                      <source data-src={image.url} type="video/mp4" />
                    </video>
                  </>
                )}
                {image.url.substring(image.url.length - 3) !== 'mp4' && (
                  <img
                    src={image.url}
                    alt={image.alt}
                    className={twMerge(
                      image.position,
                      `h-full w-full object-cover`
                    )}
                  />
                )}
              </div>
            ))}
          </div>
          <div className="content-container relative -top-[100lvh]">
            <Scrollama
              offset={0.5}
              onStepEnter={onStepEnter}
              onStepExit={onStepExit}
              // debug
            >
              {contents.map((content, stepIndex) => (
                <Step data={{ content, uuid, stepIndex }} key={stepIndex}>
                  <div className="grid grid-cols-12 gap-4">
                    <div
                      id={content.slide}
                      className="prose article-content relative z-20 col-span-8 col-start-3 place-items-end text-white *:pl-2 *:text-white xl:order-1"
                    >
                      <div className="spacer h-[50lvh]"></div>
                      <div className="innerContent w-full">
                        <h2 className="relative font-sans text-2xl leading-snug text-white drop-shadow-[0_3px_1px_rgba(0,0,0,1)] md:text-4xl xl:text-4xl">
                          {content.content}
                        </h2>
                      </div>
                      <div
                        className={
                          stepIndex === contents.length - 1
                            ? 'h-0'
                            : 'h-[50lvh]'
                        }
                      ></div>
                    </div>
                  </div>
                </Step>
              ))}
            </Scrollama>
          </div>
        </div>
      </div>
    );
  }
};
